import { ProgramBundleEntity } from "@modules/programBundle/entities/programBundleEntity"
import { ProgramInfinite } from "@modules/programs/programInfiniteTypes"
import { ProgramOnOff } from "@modules/programs/programOnOffTypes"
import { ProgramSubscriberDetailsContent } from "@modules/programs/programSubscriber/components/programSubscriberDetails/programSubscriberDetailsContent"
import { ProgramSubscriberDiscountForm } from "@modules/programs/programSubscriber/components/programSubscriberDiscountForm"
import { ProgramSubscriberInternalNoteForm } from "@modules/programs/programSubscriber/components/programSubscriberInternalNoteForm"
import { ProgramSubscriberPauseForm } from "@modules/programs/programSubscriber/components/programSubscriberPauseForm"
import { ProgramSubscriberDetailsViewTabs } from "@modules/programs/programSubscriber/entities/programSubsciberType"
import {
  useProgramSubscriberDetails,
  UseProgramSubscriberDetailsKey,
} from "@modules/programs/programSubscriber/hooks/useProgramSubscriber"
import { useState } from "react"

type ProgramSubscriberDetailsWrapperProps = {
  program: ProgramInfinite | ProgramOnOff | ProgramBundleEntity
  subscriberId: string
  className?: string
} & React.ComponentProps<"div">

export function ProgramSubscriberDetailsWrapper({
  program,
  subscriberId,
  className,
  ...props
}: ProgramSubscriberDetailsWrapperProps) {
  const defaultClassName = "flex flex-column flex-grow-1 w-full"
  const [activeTab, setActiveTab] = useState<ProgramSubscriberDetailsViewTabs>(ProgramSubscriberDetailsViewTabs.DETAILS)
  const { data: subscriberDetails } = useProgramSubscriberDetails(
    program instanceof ProgramBundleEntity
      ? UseProgramSubscriberDetailsKey.PROGRAM_BUNDLE_SUBSCRIBER
      : UseProgramSubscriberDetailsKey.PROGRAM_SUBSCRIBER,
    program.id,
    subscriberId,
  )

  return (
    <div className={className ?? defaultClassName} {...props}>
      {/* CONTENT */}
      {activeTab === ProgramSubscriberDetailsViewTabs.INTERNAL_NOTE_FORM ? (
        <ProgramSubscriberInternalNoteForm
          subscriberDetails={subscriberDetails}
          moveToSubscriberDetails={() => setActiveTab(ProgramSubscriberDetailsViewTabs.DETAILS)}
          programId={program.id}
        />
      ) : activeTab === ProgramSubscriberDetailsViewTabs.PAUSE_FORM ? (
        <ProgramSubscriberPauseForm
          subscriberDetails={subscriberDetails}
          moveToSubscriberDetails={() => setActiveTab(ProgramSubscriberDetailsViewTabs.DETAILS)}
          programId={program.id}
        />
      ) : activeTab === ProgramSubscriberDetailsViewTabs.DISCOUNT_FORM ? (
        <ProgramSubscriberDiscountForm
          subscriberDetails={subscriberDetails}
          moveToSubscriberDetails={() => setActiveTab(ProgramSubscriberDetailsViewTabs.DETAILS)}
          programId={program.id}
        />
      ) : (
        <ProgramSubscriberDetailsContent
          subscriberDetails={subscriberDetails}
          setActiveTab={setActiveTab}
          programId={program.id}
        />
      )}
    </div>
  )
}
